import { useEffect, useRef, useState } from 'react'

/**
 * Локальный тикающий таймер с ресинхронизацией по серверному значению.
 * При каждом новом значении seconds (из поллинга) таймер пересинхронизируется,
 * чтобы локальный счётчик не расходился с сервером.
 * Доходя до нуля, просто останавливается — состояние ивента переключает только бэкенд.
 *
 * @param {number|null|undefined} seconds - оставшиеся секунды из последнего ответа API
 * @returns {number} - оставшиеся секунды (не меньше 0)
 */
const useCountdown = (seconds) => {
  const [remaining, setRemaining] = useState(() => Math.max(0, Math.round(Number(seconds) || 0)))
  const targetTsRef = useRef(null)

  useEffect(() => {
    if (seconds == null) {
      setRemaining(0)
      return undefined
    }

    const value = Math.max(0, Math.round(Number(seconds) || 0))
    targetTsRef.current = Date.now() + value * 1000
    setRemaining(value)

    const interval = setInterval(() => {
      const left = Math.max(0, Math.round((targetTsRef.current - Date.now()) / 1000))
      setRemaining(left)
      if (left <= 0) {
        clearInterval(interval)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [seconds])

  return remaining
}

export default useCountdown
